import React, { Fragment, useState } from 'react';
import Stepper, { StepperPage } from '../Stepper';
import useVgsCollect from '../VgsInput/hooks/useVgsCollect';
import Complete from '../Complete';
import { deleteEmptyFields } from '../../services/vgs/fields';
import FormWrapper from './FormWrapper';
import { STATES } from '../../const';
import { FieldError } from '../VgsInput/field';
import {
  BUSINESS_STRUCTURES,
  BUSINESS_TYPES,
} from '../CreateKybKyc/Kyb/businessTypes';

export type KybData = {
  kybId: string;
  provider: VaultProvider;
};

export type SubmitProps = {
  provider: VaultProvider;
  form: VGSForm<{ vaultKybUpdate: string }>;
  kybBusinessStructure: string;
  kybBusinessType: string;
  kybAddressRegion: string;
};

export type KybFormProps = {
  provider: VaultProvider;
  onCancel?: () => void;
  onClose?: () => void;
};

const defaultBusinessType = BUSINESS_TYPES[0].value;

export default function KybForm({
  provider,
  onCancel,
  onClose,
  onSubmit,
  fieldErrors,
}: KybFormProps & {
  onSubmit: (submitProps: SubmitProps) => Promise<void>;
  fieldErrors: FieldError[];
}): React.JSX.Element {
  const [isValid, setIsValid] = useState(false);
  const [kybBusinessStructure, setKybBusinessStructure] = useState<string>(
    BUSINESS_STRUCTURES[defaultBusinessType][0].value,
  );
  const [kybBusinessType, setKybBusinessType] =
    useState<string>(defaultBusinessType);
  const [kybAddressRegion, setKybAddressRegion] = useState(STATES[0].value);

  const form = useVgsCollect<{ vaultKybUpdate: string }>();
  const steps: StepperPage[] = [
    {
      component: (
        <Fragment>
          {form !== undefined && (
            <FormWrapper
              form={form}
              onValidChange={setIsValid}
              onBusinessStructureChange={setKybBusinessStructure}
              onBusinessTypeChange={setKybBusinessType}
              onAddressRegionChange={setKybAddressRegion}
              fieldErrors={fieldErrors}
            />
          )}
        </Fragment>
      ),
      isValid,
      navigation: {
        showBack: false,
        showForward: true,
        showSteps: true,
      },
      nextText: 'Submit for review',
      beforeNext: async (): Promise<void> => {
        if (form === undefined) {
          throw new Error('VGSForm not provided');
        }
        deleteEmptyFields(form);
        await onSubmit({
          provider,
          form,
          kybBusinessStructure,
          kybBusinessType,
          kybAddressRegion,
        });
      },
      onCancel,
      srName: 'KYB Details',
      shouldRender: true,
    },
    {
      component: (
        <Complete
          onClose={(): void => {
            if (onClose !== undefined) {
              onClose();
            }
          }}
        />
      ),
      isValid: true,
      navigation: { showBack: false, showForward: false, showSteps: true },
      srName: 'KYB Details Completed',
      shouldRender: true,
    },
  ];

  return <Stepper pages={steps} showSubmitForReviewButton={true} />;
}
